import cleanDeep from 'clean-deep';
import uuid from 'uuid-v4';
import { API, graphqlOperation, Auth } from 'aws-amplify';

import {
  deleteUser,
  updateUser,
  createUser,
  createSettings,
  createCompany,
  updateTeamUser,
  createTeamUser,
} from '../graphql/mutations';
import {
  getUserByEmail,
  getUserByCompany,
  getSettingsByKey,
  getTeamByCompany,
} from '../graphql/queries';

async function makeInitPassword(email) {
  const key = `tempPassword:${btoa(email)}`;
  let result;
  let password;
  try {
    result = await API.graphql({
      query: getSettingsByKey,
      variables: { key },
      authMode: 'API_KEY',
    });
  } catch (error) {
    console.log(error);
  }
  if (result && result.data.getSettingsByKey.items.length > 0) {
    result = result.data.getSettingsByKey.items[0].val;
    password = atob(result);
    console.log(password);
  } else {
    password = Math.random().toString(36).slice(2);
    const val = btoa(password);
    await API.graphql({
      query: createSettings,
      variables: { input: { key, val } },
      authMode: 'API_KEY',
    });
  }
  return password;
}

export async function getInitPassword(email) {
  const key = `tempPassword:${btoa(email)}`;
  console.log(key);
  const result = await API.graphql({
    query: getSettingsByKey,
    variables: { key },
    authMode: 'API_KEY',
  });
  return atob(result.data.getSettingsByKey.items[0].val);
}

async function buildUser(params) {
  const password = await makeInitPassword(params.email);
  return {
    username: params.email,
    password,
    attributes: {
      email: params.email,
      'custom:firstname': params.firstName,
      'custom:lastname': params.lastName,
    },
  };
}

export const deleteUserRecord = (params) => {
  const input = cleanDeep(params);
  return API.graphql(
    graphqlOperation(deleteUser, { input }),
  );
};

export const createUserRecord = (params) => {
  const input = cleanDeep(params);
  return API.graphql(
    graphqlOperation(createUser, { input }),
  );
};

export const createTeamUserRecord = (params) => {
  const input = cleanDeep(params);
  return API.graphql(
    graphqlOperation(createTeamUser, { input }),
  );
};

export const updateTeamUserRecord = (params) => {
  const input = cleanDeep(params);
  return API.graphql(
    graphqlOperation(updateTeamUser, { input }),
  );
};

export const updateUserRecord = (params) => {
  const input = cleanDeep(params);
  return API.graphql(
    graphqlOperation(updateUser, { input }),
  );
};

export const getUserRecordsByCompany = (companyId) => API.graphql(
  graphqlOperation(getUserByCompany, { companyId }),
);

export const getUserRecordByEmail = (email) => API.graphql(
  graphqlOperation(getUserByEmail, { email }),
);

export const cognitoUserSignUp = async (attrs) => {
  const user = await buildUser(attrs);
  const signUp = await Auth.signUp(user);
  return signUp;
};

export const getSettingRecordByKey = (key) => API.graphql({
  query: getSettingsByKey,
  variables: { key },
  authMode: 'API_KEY',
});

export function confirmCognitoUserCode(userName, confirmCode) {
  return Auth.confirmSignUp(userName, confirmCode);
}

export function cognitoChangePassword(cogUser, oldP, newP) {
  return Auth.changePassword(cogUser, oldP, newP);
}

export function cognitoUserSignIn(userName, password) {
  return Auth.signIn(userName, password);
}

export function cognitoVerificationMail(userName) {
  return Auth.resendSignUp(userName);
}

export const getTeamRecordsByCompany = (companyId) => API.graphql(
  graphqlOperation(getTeamByCompany, { companyId }),
);

export const publicUserSignUp = async (params) => {
  const generatedPassword = await makeInitPassword(params.email);
  const pms = {
    username: params.email,
    password: generatedPassword,
    attributes: {
      email: params.email,
      'custom:firstname': params.firstName,
      'custom:lastname': params.lastName,
      'custom:company_name': params.companyName,
      'custom:company_address': params.companyAddress,
      'custom:city': params.city,
      'custom:phone': params.phone,
      'custom:state': params.state,
      'custom:zipcode': params.zip,
      'custom:signup': 'init',
    },
  };
  if (params.ref) {
    pms.attributes['custom:referral_code'] = params.ref;
  }
  return Auth.signUp(pms);
};
export const syncUpUser = async (cognitoUser) => {
  if (cognitoUser.attributes['custom:signup'] !== 'init') {
    throw new Error('Already Synced');
  }

  const attrs = cognitoUser.attributes;
  const companyAttrs = {
    id: uuid(),
    name: attrs['custom:company_name'],
    address: attrs['custom:company_address'],
    phone: attrs['custom:phone'],
    email: attrs.email,
    city: attrs['custom:city'],
    state: attrs['custom:state'],
    zip: attrs['custom:zipcode'],
  };
  if (attrs['custom:referral_code']) {
    companyAttrs.referralCode = attrs['custom:referral_code'];
  }
  const userAttrs = {
    id: uuid(),
    email: attrs.email,
    firstName: attrs['custom:firstname'],
    lastName: attrs['custom:lastname'],
    phone: attrs['custom:phone'],
    userType: { userType: 'Admin' },
    companyId: companyAttrs.id,
  };
  const companyPromise = new Promise((resolve, reject) => {
    API.graphql(
      graphqlOperation(
        createCompany,
        {
          input: cleanDeep(companyAttrs),
        },
      ),
    ).then((result) => {
      resolve(result);
    }).catch((e) => {
      reject(e);
    });
  });

  const userPromise = new Promise((resolve, reject) => {
    API.graphql(graphqlOperation(
      createUser,
      { input: cleanDeep(userAttrs) },
    )).then((result) => {
      resolve(result);
    }).catch((e) => {
      reject(e);
    });
  });

  const combine = new Promise((resolve, reject) => {
    let companyResult;
    let userResult;
    companyPromise.then((company) => {
      companyResult = company;
      return userPromise;
    }).then((user) => {
      userResult = user;
      resolve({ companyResult, userResult });
    }).catch((err) => {
      reject(err);
    });
  });

  combine.then((userAndCompany) => {
    console.log(userAndCompany);
    Auth.updateUserAttributes(cognitoUser, {
      'custom:signup': 'done',
    });
  });
};
